import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@upstageai/ui";

import { DP_MODEL_METADATA_MAP } from "../../constants/DpInferenceConfig";
import { OCR_MODEL_METADATA_MAP } from "../../constants/OcrInferenceConfig";
import { DpModelType } from "../../types/dpInferenceConfig";
import { OcrModelType } from "../../types/ocrInferenceConfig";

interface ConfigModelSelectProps {
  value: DpModelType | OcrModelType;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  accessibleModels: (DpModelType | OcrModelType)[];
}

export const ConfigModelSelect = ({
  value,
  onValueChange,
  disabled = false,
  accessibleModels,
}: ConfigModelSelectProps) => {
  const modelMetaDataMap = [
    ...Object.values(DP_MODEL_METADATA_MAP),
    ...Object.values(OCR_MODEL_METADATA_MAP),
  ];

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a model"></SelectValue>
      </SelectTrigger>
      <SelectContent>
        {modelMetaDataMap
          .filter(option => accessibleModels.includes(option.apiName))
          .map(option => (
            <SelectItem
              key={option.apiName}
              value={option.apiName}
              className="focus:bg-transparent"
            >
              {option.apiName}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
